// extracted by mini-css-extract-plugin
var _1 = "FileBlot-module__container--Po4IG";
export { _1 as "container" }
